import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestsService } from 'src/app/_services/tests.service';
import { ToastrService } from 'ngx-toastr';
import { Test, TestType } from 'src/app/_models/test.model';
import { showNotification } from 'src/app/helpers/show-toast';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-test',
  templateUrl: './add-test.component.html',
  styleUrls: ['./add-test.component.scss'],
})
export class AddTestComponent implements OnInit {
  pageTitle: string = 'Tests';
  testTypes: TestType[];
  editMode = false;
  test: Test = {};
  isSubmited: boolean = false;

  addTestForm = new FormGroup({
    enTestName: new FormControl(null, [Validators.required]),
    arTestName: new FormControl(null, [Validators.required]),
    testType: new FormControl(null, [Validators.required]),
    testCovidCheck: new FormControl(false, [Validators.required]),
    testBundleCheck: new FormControl(false, [Validators.required]),
  });
  constructor(
    private testService: TestsService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.getAllTestTypes();

    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.testId;
      this.getTestById(id);
    }

  }

  getTestById(testId) {
    this.testService.getTestById(testId).subscribe((res) => {
      this.test = res.data;
      this.addTestForm.patchValue({
        enTestName: this.test.name,
        arTestName: this.test.arName,
        testType: this.test.medicalServiceTypeId,
        testCovidCheck: this.test.isCovid ? true : false,
        testBundleCheck: this.test.isBundle ? true : false,
      }); 6
    });
  }

  getAllTestTypes() {
    this.testService.getAllTestTypes().subscribe((res) => {
      this.testTypes = res.data?.testTypes;
    });
  }

  buildTestObject(data) {
    this.test.name = data.enTestName;
    this.test.arName = data.arTestName;
    this.test.medicalServiceTypeId = data.testType;
    this.test.isCovid = data.testCovidCheck;
    this.test.isBundle = data.testBundleCheck;
  }

  onAddTestSubmit() {
    this.isSubmited = true;

    this.buildTestObject(this.addTestForm.value);

    if (this.addTestForm.valid) {
      if (this.editMode) {
        this.testService.updateTest(this.test).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been updated`,
            this.toastr
          );
          this.router.navigateByUrl('tests');
        });
      } else {
        this.testService.addNewTest(this.test).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.name} has been added`,
            this.toastr
          );
          this.router.navigateByUrl('tests');
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
